import { IQuickSortState } from "../../IQuickSortState";
import { IQuickSortContext } from '../../IQuickSortContext';
import { QuickSortStep } from '../../enums/QuickSortStep';
import { assertIsDefined } from "../../../tsutils/assertIsDefined";
import { QuickSortEntryState } from './QuickSortEntryState'
import { QuickSortCallEnvironment } from "../../stack/QuickSortCallEnvironment";

/**
 * Pretty much same as QuickSortInit.
 * There will be too much stuff on stack if both are used...
 * Must improve DONE
 */
export class QuickSortCallState implements IQuickSortState {

  ThisQuickSortStep = QuickSortStep.QuickSortCall;
  
  Description = "(Init) Call QuickSort (push values to stack)";

  private _savedState : { 
    PushedObjects: Array<any> | undefined
   } | undefined;

  private _context : IQuickSortContext | undefined;
  
  SetContext(context: IQuickSortContext): void {
    this._context = context;
  } 
  
  Do(): void {
    
    assertIsDefined(this._context);
    assertIsDefined(this._context.Numbers);
    assertIsDefined(this._context.AlgoStack);

    let numbers: Array<number> = this._context.Numbers;
    let lo: number = 0;
    let hi: number = numbers.length - 1;

    let callEnvironment : QuickSortCallEnvironment = {
      CallerStep: this.ThisQuickSortStep,
      CallerPartitionIndex: this._context.PartitionIndex,
      CallerHi: this._context.Hi,
      CallerLo: this._context.Lo
    }    

    if (this._savedState === undefined) {
      this._savedState = {
        PushedObjects: [numbers, lo, hi, callEnvironment]
      }
    }
    else {
      this._savedState.PushedObjects = [numbers, lo, hi, callEnvironment];
    }

    this._context.AlgoStack.push(callEnvironment);
    this._context.AlgoStack.push(hi);
    this._context.AlgoStack.push(lo);
    this._context.AlgoStack.push(numbers);
  }

  Undo(): void {
    assertIsDefined(this._context);
    assertIsDefined(this._context.Numbers);
    assertIsDefined(this._context.AlgoStack);
    assertIsDefined(this._savedState);
    assertIsDefined(this._savedState.PushedObjects);

    this._context.AlgoStack.pop();
    this._context.AlgoStack.pop();
    this._context.AlgoStack.pop();
    this._context.AlgoStack.pop();
  }

  Exit(): void {
    if (this._context) {
      this._context.TransitionTo(new QuickSortEntryState());
    }
  }
}